<template>
  <div>
    <nav class="navbar">
      <div v-if="status" class="nav-left flex">
        <button type="button" class="btn btn-back nav-back mr-1" @click="$router.push('/reports/ratings')" />
        <h2 class="pl-4">{{ name }}</h2>
        <div class="pl-4" v-if="status">
          <span v-if="status === 'Active'"
                :class="'btn-status btn-active'"
          >{{ status }}</span>
          <span v-if="status === 'Inactive'"
                :class="'btn-status btn-pending'"
          >{{ status }}</span>
          <span v-if="status === 'Setup Incomplete'"
                :class="'btn-status btn-rejected'"
          >{{ status }}</span>
        </div>
      </div>
    </nav>
  </div>
</template>
<script>
export default {
  props: {
    name: {
      type: String,
      default: '',
    },
    status: {
      type: String,
      default: '',
    },
  },
};
</script>
<style lang="scss" scoped>
nav.navbar {
  height: 62px;
  background-color: #ffffff;
  width: 100%;
}

.nav-back {
  margin: 0 0 0 5px;
}

.nav-left,
.nav-right {
  align-items: center;
}

.nav-left .nav-item {
  margin: 0 12px 0 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/reports/ratings/CompanyRatingsHeader.vue